// extracted by mini-css-extract-plugin
export default {"userResearchContainer":"UserResearch_userResearchContainer__0petC","userResearch":"UserResearch_userResearch__Ao9am","userInterviewsImage":"UserResearch_userInterviewsImage__YzlE5"};